import { observable,action } from 'mobx'
class TapBarStore {
    @observable toastShow = false;
    @observable history = '/';
    @observable contant = '';
    // 通过action更改内容
    @action changeTabShow (val) {
        this.toastShow = val;
    }
    @action changeHistory (val) {
        this.history = val;
    }
    @action changeContant(val) {
        this.contant = val;
    }
}
export default TapBarStore;